import { useEffect, useState } from "react";
import {
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonPage,
  IonTitle,
} from "@ionic/react";

import { IEneatipo, TipoRasgo } from "../../entities/IEneatipo";
import { Loading } from "../../components/Loading";
import Axios from "axios";
import config from "../../config.json";
import { useParams } from "react-router";

interface IModel {
  key: string;
  nombre: string;
  rasgos:
    | {
        tipo: TipoRasgo;
        descripcion: string;
      }[]
    | undefined;
}

export const Eneatipo = () => {
  const [data, setData] = useState<IEneatipo | undefined>(undefined);
  let { id } = useParams<{ id: string | undefined }>();
  useEffect(() => {
    if (!data || data?.id !== parseInt(id || "0")) {
      Axios.get<IEneatipo>(config.api.eneatipo + "/" + id).then((x) =>
        setData(x.data)
      );
    }
  });

  let titulos: { [key: number]: string } = {
    [TipoRasgo.descriptivo]: "Cómo es",
    [TipoRasgo.bueno]: "Lo bueno",
    [TipoRasgo.malo]: "En sus peores momentos",
    [TipoRasgo.informativo]: "Y además",
  };

  let info = Object.keys(titulos).map((x) => {
    return {
      key: x,
      nombre: titulos[x as any],
      rasgos: data?.rasgos.filter((y) => y.tipo == (x as any)),
    };
  });

  let header = process.env.PUBLIC_URL + `/imgs/eneatipos/titular/${id}.jpg`;
  let ficha = process.env.PUBLIC_URL + `/imgs/eneatipos/cartas/${id}.png`;

  return (
    <IonPage>
      <br />
      <IonContent fullscreen>
        <Loading loading={!data}>
          <div
            style={{
              height: "30vh",
              background:
                "url('https://terapiasenergeticas.org/wp-content/uploads/2021/04/2-sunset.jpg')",
              backgroundAttachment: "fixed",
            }}
          ></div>
          <div
            style={{ textAlign: "center", top: "-13vh", position: "relative" }}
          >
            <img
              src="https://static.thenounproject.com/png/2366460-200.png"
              style={{
                width: "25vh",
                backgroundColor: "white",
                borderRadius: "50%",
              }}
            />
            <br />
            <img src={header} style={{ width: "50vh" }} />
            <h1 style={{ fontWeight: "bolder" }}>{data?.nombre}</h1>
          </div>

          <IonList>
            {info.map((e) => (
              <Elemento element={e} />
            ))}
          </IonList>
          <img src={ficha} />
        </Loading>
      </IonContent>
    </IonPage>
  );
};

const Elemento = (props: { element: IModel }) => {
  return (
    <>
      <IonListHeader>
        <IonTitle>
          <h2>{props.element.nombre}</h2>
        </IonTitle>
      </IonListHeader>
      <IonItem>
        <IonLabel className="ion-text-wrap">
          {props.element.rasgos?.map((x, i) => {
            return <p key={i}>{x.descripcion}</p>;
          })}
        </IonLabel>
      </IonItem>
    </>
  );
};
